import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=50acfece&scoped=true&"
import script from "./CallHistory.vue?vue&type=script&lang=js&"
export * from "./CallHistory.vue?vue&type=script&lang=js&"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=50acfece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50acfece",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VBtn,VDivider,VHover,VIcon,VList,VListItem,VListItemContent})
